import type { IconNode } from '../types';

/**
 * @name stairs-arrow-up-right
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMyAxMSA5LTkiIC8+CiAgPHBhdGggZD0iTTggMmg0djQiIC8+CiAgPHBhdGggZD0iTTIgMjBoNXYtNWg1di01aDVWNWg1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/stairs-arrow-up-right
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const stairsArrowUpRight: IconNode = [
  ['path', { d: 'm3 11 9-9', key: '1tx5f3' }],
  ['path', { d: 'M8 2h4v4', key: 'ikvxr7' }],
  ['path', { d: 'M2 20h5v-5h5v-5h5V5h5', key: '13vrqq' }],
];

export default stairsArrowUpRight;
